import { deadlineDaysBefore } from "./dates";

/**
 * When wedding stationery goes out, in days before the wedding: the usual windows (local and destination weddings)
 * behind the free "when to send wedding invitations" tool on bridewell.io. The latest dates are the checklist's own
 * phase deadlines (`deadlineDaysBefore`), so the tool never contradicts the plan the app keeps: save-the-dates belong
 * to "3–6 months before", invitations to "1–3 months before", the final head count to "1 month before".
 */
export const INVITATION_TIMING = {
  /** Save-the-dates: 8 to 6 months before (12 to 8 for a destination wedding). */
  saveTheDate: { local: { from: 240, to: 180 }, destination: { from: 365, to: 240 }, latest: deadlineDaysBefore("threeToSix")! },
  /** Invitations: 8 to 6 weeks before (about 3 months to 10 weeks for a destination wedding). */
  invitations: { local: { from: 56, to: 42 }, destination: { from: 90, to: 70 }, latest: deadlineDaysBefore("oneToThree")! },
  /** The reply-by date printed on the invitation: 4 to 3 weeks before. */
  rsvpDeadline: { from: 28, to: 21 },
  /** "Confirm final guest count" with the venue and caterer: the checklist's last-month deadline. */
  finalCount: deadlineDaysBefore("oneMonth")!,
} as const;
